// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpdesk {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.helpdesk__content {
  width: 83%;
}

.helpdesk__submit {
  width: 17%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/helpdesk/Helpdesk.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".helpdesk {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.helpdesk__content {\n  width: 83%;\n}\n\n.helpdesk__submit {\n  width: 17%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
